import AppBarh from "../components/AppBarh";
import Footer from "../components/Footer";
import MembershipView from "../components/MembershipView";
import {Box, Button, Grid, Typography} from "@mui/material";
import tokenid from "../assets/images/Token.png";
import ipglogo from '../assets/images/PayHereLogo.png';

export default function MemberRegistration() {
    const pdfFilePath = 'https://uwualumni.com/constitution.pdf'; // Relative path from the public folder
    const iframestyle = {};
    const redirectToRegistration = () => {
        // window.location.href = '/undercons';
        window.location.href = 'https://app.rewavo.com/alumni-registration';
    };
    return (
        <div className="Example">
            <AppBarh/>
            <Grid item xs={12} sx={{mx: '4%', mt: '2%'}}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <Typography variant='h4'>Member Registration</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{display: 'flex', justifyContent: 'center', mx: '3%'}}>
                            <Button
                                color={'primary'}
                                variant='contained'
                                size='large'
                                onClick={redirectToRegistration}
                                sx={{textAlign: 'center', textTransform: 'capitalize'}}
                            >
                                <Typography variant='subtitle1' sx={{color: 'white', fontWeight: 'bold'}}>Register
                                    Now!</Typography>
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Box sx={{mx: '1%', mb: '3%'}}>
                <Box sx={{ml: '4%'}}>
                    <Box sx={{mt: '3%', mb: '1%', mx: '4%', display: 'flex', justifyContent: 'center'}}>
                        <Typography variant='h6' sx={{my: '1%'}}> Great Opportunity to Join the Prestigious UWU Alumni
                            Community!</Typography>
                    </Box>

                     <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            mx: '10%',
                                                            mt: '5%',
                                                            mb: '2%',

                                                        }}
                                                    >

                                                        <MembershipView/>
                                                    </Box>
            <Box sx={{my: '2%'}}><hr/></Box>

                    <Box>
                        <Typography variant='h6'>Registration Instruction</Typography>

                        <Box>
                            <Typography variant='subtitle1' sx={{mt: '1%', ml: '4%'}}>
                                <li><strong>Personal Information:</strong></li>
                                <Typography variant='body1' sx={{ml: '2%'}}>
                                    Provide accurate and up-to-date personal details, including your full name, contact information, and other relevant information.
                                </Typography>
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant='subtitle1' sx={{mt: '1%', ml: '4%'}}>
                                <li><strong>Professional Information:</strong></li>
                                <Typography variant='body1' sx={{ml: '2%'}}>Fill in your professional details, such as your current occupation/ designation, and other pertinent information.</Typography>
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant='subtitle1' sx={{mt: '1%', ml: '4%'}}>
                                 <li><strong>Payment Methods:</strong></li>
                                  <Box sx={{ display: 'flex', alignItems: 'center', ml: '2%', mt: '0.5%', gap: '1px' }}>
                                        <Typography variant='body1'>🔸</Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
                                          <img src={ipglogo} alt="PayHere" style={{ height: 32, width: 'auto' }} />
                                          <Typography variant='body1' sx={{ whiteSpace: 'nowrap' }}>Online Transfer</Typography>
                                        </Box>
                                      </Box>
                                 <Typography variant='body1' sx={{ml: '2%'}}>🔸 Bank Transfers </Typography>
                                 <Typography variant='body1' sx={{ml: '2%'}}>🔸 Cash Payments </Typography>
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant='subtitle1' sx={{mt: '1%', ml: '4%'}}>
                                <li><strong>Required Documents:</strong></li>


                                <Typography variant='body1' sx={{mt: '1%', ml: '2%'}}>1. Profile Picture:</Typography>
                                <Typography variant='body1' sx={{ml: '4%'}}>Upload a clear and recent profile picture <strong><span
                                        style={{color: '#555555'}}>(.jpeg, .png, .jpg)</span></strong> </Typography>


                                <Typography variant='body1' sx={{mt: '1%', ml: '2%'}}>2. Degree Certificate: (Optional)</Typography>
                                <Typography sx={{mt: '1%', ml: '4%'}}>Attach a scanned copy or clear image  <strong><span
                                        style={{color: '#555555'}}>(.jpeg, .png, .jpg, .pdf)</span></strong> of your degree certificate/academic transcript.</Typography>


                                <Typography variant='body1' sx={{mt: '1%', ml: '2%'}}>3. Payment Confirmation: (Not needed if using PayHere online transfer) </Typography>
                                <Typography sx={{mt: '1%', ml: '4%'}}> Ensure payment is completed before finalizing registration if using bank transfers or cash payments. </Typography>




                                <Typography variant='body1' sx={{mt: '1%', ml: '4%'}}>3.a. Bank Payment
                                    Slip:</Typography>

                                <Typography sx={{ml: '6%', '& ul': {paddingInlineStart: 2, listStyleType: 'none'}}}>
                                    <ul>

                                    <span style={{color: '#e77817'}}>
                                        <li>Bank: <strong>Commercial Bank </strong></li>
                                        <li>Bank Code: <strong>7056</strong></li>
                                        <li>Branch:<strong> Rajagiriya Branch</strong></li>
                                        <li>Branch Code:<strong> 62</strong></li>
                                        <li>Account Name:<strong> Alumni Association of Uva Wellassa University</strong></li>
                                        <li>Account Number: <strong>8019717186</strong></li>
                                        <li>Swift Code:<strong> CCEYLKLX</strong></li>
                                    </span>
                                    </ul>
                                </Typography>
                                <Typography variant='body1' sx={{ml: '6%'}}>Upload a picture in formats <strong><span
                                    style={{color: '#555555'}}>(.jpeg, .png, .jpg)</span></strong> or PDF
                                    file<strong><span style={{color: '#555555'}}>(.pdf)</span></strong> of the bank
                                    payment slip post-payment to confirm your registration.</Typography>


                                 <br/>



                                <Typography variant='body1' sx={{mt: '1%', ml: '4%'}}>3.b. Cash Token Details:
                                </Typography>
                                <Typography variant='body1' sx={{mt: '1%', ml: '6%'}}> For cash payments, purchase a valid token card from the Alumni Association of Uva Wellassa University. Tokens are available at UWU events.</Typography>
                                <br/>
                                    <Typography variant='body1' sx={{ml: '6%'}}>Upload a picture in formats<strong><span
                                        style={{color: '#555555'}}>(.jpeg, .png, .jpg)</span></strong> or PDF
                                    file<strong><span style={{color: '#555555'}}>(.pdf)</span></strong> of the cash token for verification.</Typography>
                                <Box width='100%' sx={{display: 'flex', justifyContent: 'center', my: '2%'}}>
                                    <img src={tokenid} alt=""/>
                                </Box>
                            </Typography>
                            <Typography sx={{color: '#555555', mt: '1%', ml: '6%'}}>Before initiating registration, ensure you have the necessary documents ready:
                            <strong> Profile Picture</strong> / <strong>Bank Receipts</strong> / <strong>Cash Token</strong>.</Typography>
                        </Box>


                        <Box>
                            <Typography variant='subtitle1' sx={{mt: '2%', color: '#F27013'}}><strong>Please note
                                :</strong></Typography>
                            <Typography variant='body1' sx={{mt: '1%', ml: '2%', color: '#F27013'}}>
                                <li>Verify the accuracy of all the provided informations.</li>
                                <li>If paying by cash token, purchase a valid token card from UWU Alumni.
                                </li>
                                <li>Double-check bank details or cash token details before making payment.</li>

                            </Typography>

                        </Box>
                    </Box>
                </Box>
                <Box sx={{my: '2%'}}>
                    <hr/>
                </Box>

                <Box sx={{ml: '6%', my: '2%'}}>



                    <Typography variant={'h6'}>Why register with UWU Alumni?</Typography>
                    <Box sx={{ml: '2%'}}>
                                            <Box sx={{mt: '1%'}}>
                                                <Typography sx={{ml: '2%'}}>✅ Networking: Build professional connections and mentorship opportunities.
                                                </Typography>
                                            </Box>
                                            <Box sx={{mt: '1%'}}>
                                               <Typography sx={{ml: '2%'}}>✅ Stay Informed: Get updates on UWU achievements, news, and programs.
                                                </Typography>
                                            </Box>
                                            <Box sx={{mt: '1%'}}>
                                                <Typography sx={{ml: '2%'}}>✅ Recognition: Strengthen ties with UWU for a sense of belonging.
                                                </Typography>
                                            </Box>
                                            <Box sx={{mt: '1%'}}>
                                               <Typography sx={{ml: '2%'}}>✅ Exclusive Benefits: Job services, education discounts, and event invites.
                                                </Typography>
                                            </Box>
                                        </Box>


                    <Typography variant={'h6'} sx={{mt: '2%'}}>Why do we need an Alumni association?</Typography>
                    <Box sx={{ml: '2%'}}>
                        <Box sx={{mt: '1%'}}>
                                                    <Typography sx={{ml: '2%'}}>🔷 Cohesion: Unite graduates to enhance UWU’s reputation.
                                                    </Typography>
                                                </Box>
                                                <Box sx={{mt: '1%'}}>
                                                    <Typography sx={{ml: '2%'}}>🔷 Information Hub: Stay updated on university and community news.
                                                    </Typography>
                                                </Box>
                                                <Box sx={{mt: '1%'}}>
                                                   <Typography sx={{ml: '2%'}}>🔷 Empowerment: Access personal and professional development programs.
                                                    </Typography>
                                                </Box>
                                                <Box sx={{mt: '1%'}}>
                                                   <Typography sx={{ml: '2%'}}>🔷 Academic Excellence: Support UWU’s journey toward scholastic brilliance.
                                                    </Typography>
                                                </Box>
                                                <Box sx={{mt: '1%'}}>
                                                   <Typography sx={{ml: '2%'}}>🔷 Future-Ready Graduates: Help undergraduates transition smoothly into careers.
                                                    </Typography>
                                                </Box>
                    </Box>
                </Box>

                <Box sx={{my: '2%'}}><hr/></Box>

                    <Typography sx={{mt: '1%', textAlign:'center'}}>
                        <strong>Seize the opportunity! Register today and enjoy exclusive benefits tailored for UWU alumni.</strong> <br/> Contact us at <a
                    href={'mailto:alumni@std.uwu.ac.lk'}> alumni@std.uwu.ac.lk</a> for any registration-related queries
                    or concerns.
                </Typography>

                <Box sx={{display: 'flex', justifyContent: 'center', m: '3%'}}>
                    <Button
                        color={'primary'}
                        variant='contained'
                        size='large'
                        onClick={redirectToRegistration}
                        sx={{textAlign: 'center', textTransform: 'capitalize'}}
                    >
                        <Typography variant='subtitle1' sx={{color: 'white', fontWeight: 'bold'}}>Register
                            Now!</Typography>
                    </Button>
                </Box>
            </Box>
            <Footer/>
        </div>
    );
}
